import { LINK_COLOR } from 'app/constants/Colors';
import { buttonReset } from 'app/constants/Styles';
import { IStyles } from 'app/utils/css';

export const getLinkStyles: () => IStyles = () => ({
  ...buttonReset, // Allow link style to be used for buttons
  textAlign: 'left',  // Override this style from buttonReset.
  color: LINK_COLOR,
  ':focus': {
    textDecoration: 'underline',
  },
});
